import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { fetchLeaderboard, toggleLeaderboard } from '_redux/actioncreators/leaderboard';
import { Translate, translateKey } from '_translations';

import Filters from './Filters';
import Board from './Board';

class Leaderboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 0,
      selectedCountry: this.getInitalCountry(),
      searchTerm: '',
      scrollPosition: 0,
    };

    this.leaderboard = React.createRef();
    this.leaderboardScrollContainer = React.createRef();
    this.getLeaderboardEntries();
  }

  render() {
    return (
      <aside className={`leaderboard ${this.props.leaderboard.isOpen ? 'is-open' : ''}`} ref={this.leaderboard}>
        <button onClick={() => this.props.toggleLeaderboard(this.props.leaderboard.isOpen)} className="title-panel">
          <span><Translate resourceString="Thunderbolt.Leaderboard" /></span>
        </button>

        <div className="leaderboard__inner" ref={this.leaderboardScrollContainer}>
          <Filters
            {...this.props}
            selectedCountry={this.state.selectedCountry}
            handleCountrySelected={this.handleCountrySelected}
            handleSearchChange={this.handleSearchChange}
            searchTerm={this.state.searchTerm}>
          </Filters>
          <Board
            {...this.props}
            loadMore={this.loadMore}
            searchTerm={this.state.searchTerm}
            selectedCountry={this.state.selectedCountry}>
          </Board>
        </div>
      </aside>
    );
  }

  loadMore = () => this.setState({
    pageNumber: this.state.pageNumber + 1,
  }, this.getLeaderboardEntries);

  handleSearchChange = (event) => {
    this.setState({
      searchTerm: event.target.value,
      pageNumber: 0,
    }, this.handleSearchDebounce);
  }

  handleSearchDebounce = debounce(() => {
    this.getLeaderboardEntries();
  }, 275);

  handleCountrySelected = (selectedItem) => {
    this.setState({
      selectedCountry: selectedItem,
      pageNumber: 0,
    }, this.getLeaderboardEntries);
  }

  getLeaderboardEntries = () => {
    let selectedFilterOption;

    if (this.props.cultureCode.toLowerCase() !== 'en-tt') {
      // If a culture version, default the leaderboard to their culture only.
      selectedFilterOption = this.props.cultureCode;
    } else {
      // If EU, default to the top entry per region.
      selectedFilterOption = '(top_per_region)';
    }

    if (this.state.selectedCountry !== null) {
      selectedFilterOption = this.state.selectedCountry.value;
    }

    this.props.fetchLeaderboard({
      userCultureCode: this.props.cultureCode,
      selectedFilterOption,
      pageNumber: this.state.pageNumber,
      searchTerm: this.state.searchTerm,
    });
  }

  getInitalCountry = () => {
    if (this.props.cultureCode.toLowerCase() !== 'en-tt') {
      return { label: translateKey(`lang_${this.props.cultureCode}`), value: this.props.cultureCode };
    }

    return { label: translateKey('Thunderbolt.Leaderboard.Finalists'), value: '(top_per_region)' };
  }
}

const mapStateToProps = state => ({
  leaderboard: state.app.leaderboard,
});

const mapDispatchToProps = dispatch => ({
  fetchLeaderboard: params => dispatch(fetchLeaderboard(params)),
  toggleLeaderboard: isOpen => dispatch(toggleLeaderboard(isOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboard);
